/** O alinhamento do texto; imagem, vídeo e YouTube só usam esquerda, centro e direita. */
export enum AnnouncementAlignment {
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right',
  JUSTIFY = 'justify',
}

/** O nome do nó do editor que mostra a mídia: o mesmo no editor, na leitura e no envio. */
export enum AnnouncementMediaNode {
  IMAGE = 'image',
  VIDEO = 'video',
  YOUTUBE = 'youtube',
}

/** A largura da mídia em relação ao texto: a mesma proporção no editor, na leitura e no celular. */
export enum AnnouncementMediaSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
  FULL = 'full',
}
